import { render, staticRenderFns } from "./xuanke.vue?vue&type=template&id=5c502120&scoped=true&"
import script from "./xuanke.vue?vue&type=script&lang=js&"
export * from "./xuanke.vue?vue&type=script&lang=js&"
import style0 from "./xuanke.vue?vue&type=style&index=0&id=5c502120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c502120",
  null
  
)

export default component.exports